import { useEffect } from 'react';
import NotificationService from '../services/notification.service';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const toastData = (data) => {
  const result = {
    content: null,
    options: {
      icon: false,
      type: 'success',
    },
  };

  switch (data.code) {
    case 'myta-token':
      result.content = `Вам начислено ${data.body?.amount || 0} очков активности`;
      result.options.icon = (
        <img className="size-[16px]" src="/icons/myta-coin.svg" alt="myta-coin" className="size-5" />
      );
      break;
    case 'myta-coins':
      result.content = `Вам начислено ${data.body?.amount || 0} койнов`;
      result.options.icon = <img className="size-[16px]" src="/icons/coin.svg" alt="coin" className="size-5" />;
      break;
    case 'buy-sub':
      result.content = data.body?.text || 'Спасибо за доверие! Ваша подписка Myta Premium успешно оформлена';
      result.options.icon = <img src="/icons/toast-success.svg" alt="" className="size-5" />;
      break;

    default:
      result.content = 'У вас новое уведомление!';
      break;
  }

  return result;
};

export function SenderProvider({ children }) {
  const token = useSelector((state) => state.auth.auth_token);

  useEffect(() => {
    const authToken = token || localStorage.getItem('auth_token');

    if (!authToken) {
      return undefined;
    }

    NotificationService.connect(authToken);
    const osubSender = NotificationService.onSend((data) => {
      console.log('NotificationService', data);

      const toastContent = toastData(data.data);

      toast(toastContent.content, toastContent.options);
    });

    return () => {
      osubSender();
      NotificationService.disconnect();
    };
  }, [token]);

  return children;
}
